var React = require('react');

function AngleLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.248 14a.986.986 0 0 1-.636-.232L3.75 8.003l6.871-5.77a.988.988 0 0 1 1.398.126 1.005 1.005 0 0 1-.126 1.41L6.85 8.002l5.035 4.23c.42.353.477.983.126 1.408a.991.991 0 0 1-.763.36z"}));
}

AngleLeft.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = AngleLeft;

AngleLeft.default = AngleLeft;
